<template>
  <div :id="$style.button" :style="styles">
    <router-link :to="link">{{ title }}</router-link>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "MoreInfoBigButton",
  props: {
    title: {
      type: String,
      default: "BigButton"
    },
    link: {
      type: String,
      default: "/"
    },
    color: {},
    background: {}
  },

  computed: {
    // バインドするスタイルを生成
    styles() {
      return {
        "--color": this.color,
        "--background": this.background
      };
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $radius_size: 30px;
  $button_height: 48px;
  // $button_width: 162px;
  $button_width: 184px;
  $font_size: 19px;

  #button {
    // デフォルトの値を宣言
    --color: #000;
    --background: #fff;
    position: relative;
    height: $button_height;
    width: $button_width;
    border: 1px solid;
    border-color: var(--color);
    border-radius: $radius_size;
    background: var(--background);

    a {
      position: absolute;
      text-decoration: none;
      height: 100%;
      width: 100%;
      border-radius: $radius_size;
      color: var(--color);
      font-size: $font_size;

      // 文字の中央揃え
      text-align: center;
      line-height: $button_height;
    }
  }
}
@media only screen and (min-width: 1024px) {
  $radius_size: 30px;
  $button_height: 48px;
  // $button_width: 162px;
  $button_width: 184px;
  $font_size: 19px;

  #button {
    // デフォルトの値を宣言
    --color: #000;
    --background: #fff;
    position: relative;
    height: $button_height;
    width: $button_width;
    border: 1px solid;
    border-color: var(--color);
    border-radius: $radius_size;
    background: var(--background);

    a {
      position: absolute;
      text-decoration: none;
      height: 100%;
      width: 100%;
      border-radius: $radius_size;
      color: var(--color);
      font-size: $font_size;

      // 文字の中央揃え
      text-align: center;
      line-height: $button_height;
    }
    a:hover {
      background: rgba(#403f3f, 0.1);
    }
  }
}
</style>
